import React, { useContext } from "react";

import "../styles/Chart.css";
import { HandCombosContext, InputValidationContext } from "../context/store";
import {
  ActionTypes,
  BOARD_ERROR_CLASS,
  BOARD_TITLE_CLASS,
  ValidationTypes
} from "../constants";

export function BoardInput(props) {
  const [selectedCombos, handleSelectedDispatch] = useContext(
    HandCombosContext
  );
  const [inputValdation, validationDispatch] = useContext(
    InputValidationContext
  );
  const gridStyle = {
    display: "grid",
    gridTemplateRows: "minmax(0, 30px) auto",
    gridTemplateColumns: "auto minmax(0, 1fr)",
    columnGap: "6px",
    alignItems: "center",
    minWidth: "0%",
    minHeight: "0%"
  };
  const inputStyle = {
    gridColumn: 2,
    gridRow: 1,
    boxSizing: "border-box",
    width: "100%",
    padding: "5px 6px",
    border: "1px solid #8fa0a8",
    borderRadius: "3px"
  };
  const validationStyle = {
    gridColumn: "1 / -1",
    gridRow: 2,
    width: "100%",
    color: "#d03234",
    fontSize: ".7rem",
    overflowWrap: "anywhere"
  };
  function handleChange(e) {
    // TODO: Form validation
    handleSelectedDispatch({
      type: ActionTypes.UPDATE_BOARD,
      board: e.target.value
    });
  }
  const isValid = inputValdation.type === ValidationTypes.VALID;
  const boardText = "Board:";
  // Sits on the dark rail now, so the resting color is the rail's dim text.
  const titleColor = isValid ? "#aebac1" : "#d03234";
  const inputValue = selectedCombos["board"];
  const titleStyle = {
    gridColumn: 1,
    gridRow: 1,
    textAlign: "left",
    color: titleColor,
    fontSize: ".72rem",
    minWidth: "0%",
    minHeight: "0%"
  };
  return (
    <div style={gridStyle}>
      <span className={BOARD_TITLE_CLASS} style={titleStyle}>
        {boardText}
      </span>
      <input
        placeholder="ex: AsKcQdTh9s"
        value={inputValue}
        style={inputStyle}
        onChange={handleChange}
      />
      <span className={BOARD_ERROR_CLASS} style={validationStyle}>
        {inputValdation.error}
      </span>
    </div>
  );
}
